import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (data.data?.[0]?.errorMsg) {
    throw {
      errorMsg: data.data?.[0]?.errorMsg,
      errorCode: data.data?.[0]?.errorCode,
    }
  }
  return data?.data
}

export const getBankIfsc = (bankName: string, ifscCode: string, tokens: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.getBankIfsc,
    //apiPath: 'http://10.162.6.163:9012/jpb/v1/aeps/common/banks',
    method: 'POST',
    config: config,
    body: {
      bankName: bankName,
      ifscCode: ifscCode,
    },
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
